export default function Music(){
    return (
        <div id="music" className="music">
            <div className='player'>
                <iframe src="https://open.spotify.com/embed/artist/65axA3vgtIapvUO3pyZfbs?utm_source=generator&theme=0" width="100%" height="80%" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe> 
            </div>
        </div>
        );
    }